import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Sparkles, Loader2, Edit, Save, X, FileText } from 'lucide-react';
import axios from 'axios';
import SectionHeader from './shared/SectionHeader';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProjectSummary = ({ project }) => {
  const [summary, setSummary] = useState(project.summary || '');
  const [isEditing, setIsEditing] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateSummary = async () => {
    setIsGenerating(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/ai/generate-project-summary`, {
        projectId: project.id
      });
      
      setSummary(response.data.summary);
      setIsEditing(true);
    } catch (error) {
      console.error('Error generating summary:', error);
      alert('Failed to generate summary. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleSave = () => {
    // This will be implemented with backend
    alert('Summary save will be implemented with backend');
    setIsEditing(false);
  };

  const headerActions = !isEditing ? (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={handleGenerateSummary}
        disabled={isGenerating}
        className="border-purple-500 text-purple-500 hover:bg-purple-500/10"
      >
        {isGenerating ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Generating...
          </>
        ) : (
          <>
            <Sparkles className="w-4 h-4 mr-2" />
            AI Generate
          </>
        )}
      </Button>
      <Button variant="ghost" size="sm" onClick={() => setIsEditing(true)} className="text-foreground">
        <Edit className="w-4 h-4" />
      </Button>
    </>
  ) : (
    <>
      <Button variant="ghost" size="sm" onClick={() => setIsEditing(false)} className="text-foreground">
        <X className="w-4 h-4" />
      </Button>
      <Button size="sm" onClick={handleSave} className="bg-primary hover:bg-primary/90 text-primary-foreground">
        <Save className="w-4 h-4 mr-2" />
        Save
      </Button>
    </>
  );

  return (
    <SectionHeader
      title="Project Summary"
      icon={FileText}
      iconColor="text-purple-500"
      badge={project.createdWithAI && (
        <span className="text-xs bg-purple-500/20 text-purple-400 px-2 py-1 rounded-full">
          AI Created
        </span>
      )}
      actions={headerActions}
    >
      {isEditing ? (
        <Textarea
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          placeholder="Enter project summary or generate one with AI..."
          rows={5}
          className="w-full"
        />
      ) : (
        <div className="text-foreground leading-relaxed">
          {summary || (
            <div className="text-center py-8 text-muted-foreground">
              <p className="mb-3">No summary available yet</p>
              <Button
                variant="outline"
                onClick={handleGenerateSummary}
                disabled={isGenerating}
                className="border-purple-500 text-purple-500 hover:bg-purple-500/10"
              >
                {isGenerating ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Generating...
                  </>
                ) : (
                  <>
                    <Sparkles className="w-4 h-4 mr-2" />
                    Generate Summary with AI
                  </>
                )}
              </Button>
            </div>
          )}
        </div>
      )}
    </SectionHeader>
  );
};

export default ProjectSummary;
